module.exports = __webpack_public_path__ + "files/d1addba006e58f37f64166c0bf95aaf4.png";